import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar.component';
import { RouterModule } from '@angular/router';
import { LogoutDialogModule } from '../logout-dialog/logout-dialog.module';



@NgModule({
  declarations: [SidebarComponent],
  imports: [
    CommonModule,
    LogoutDialogModule,
    RouterModule
  ],
  exports: [
    SidebarComponent
  ]
})
export class SidebarModule { }
